import React from 'react';
import styled from 'styled-components';

const DocsPage = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
  
  h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.8rem;
    font-weight: 600;
    color: #ffffff;
    margin: 2rem 0 1rem 0;
    line-height: 1.3;
  }
  
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #ffffff;
    margin: 1.5rem 0 0.75rem 0;
    line-height: 1.4;
  }
  
  h4 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    margin: 1.25rem 0 0.5rem 0;
  }
  
  p {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 1rem;
  }
  
  strong {
    color: #ffffff;
    font-weight: 600;
  }
  
  ul, ol {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }
  
  li {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 0.5rem;
  }
  
  code {
    font-family: 'monospace', sans-serif;
    background: rgba(0, 0, 0, 0.3);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.9em;
    color: #a855f7;
  }
  
  a {
    color: #a855f7;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.2s ease;
    
    &:hover {
      color: #10b981;
      text-decoration: underline;
    }
  }
  
  .step {
    background: rgba(168, 85, 247, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 1.5rem 0;
  }
  
  .step-number {
    background: #a855f7;
    color: #ffffff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
  
  .step-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.75rem;
  }
  
  .step-content {
    font-family: 'Inter', sans-serif;
    color: #e5e7eb;
    line-height: 1.6;
  }
  
  .info-box {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .info-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #3b82f6;
    margin-bottom: 1rem;
  }
  
  .success-box {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .success-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  .warning-box {
    background: rgba(245, 158, 11, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .warning-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #f59e0b;
    margin-bottom: 1rem;
  }
  
  .purple-box {
    background: rgba(168, 85, 247, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .purple-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #a855f7;
    margin-bottom: 1rem;
  }
  
  .example-box {
    background: rgba(16, 185, 129, 0.05);
    padding: 1.5rem;
    margin: 2rem 0;
    border-radius: 8px;
  }
  
  .example-title {
    color: #10b981;
    font-weight: 700;
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
  
  .highlight-box {
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.1), rgba(16, 185, 129, 0.1));
    border-radius: 16px;
    padding: 2rem;
    margin: 2.5rem 0;
    text-align: center;
  }
  
  .highlight-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1rem;
  }
  
  .highlight-text {
    font-size: 1.1rem;
    color: #e5e7eb;
    line-height: 1.7;
  }
`;

const TydroLeveragedTrading: React.FC = () => {
  return (
    <DocsPage>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <img 
          src="/tydro_lockup_white.png" 
          alt="Tydro" 
          style={{ 
            maxWidth: '300px', 
            width: '100%', 
            height: 'auto',
            marginBottom: '1.5rem'
          }} 
        />
      </div>
      
      <h1>Tydro Leveraged Spot Trading</h1>
      
      <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
        Amplify your capital. Trade hundreds of Mavrk ecosystem tokens on Ink with borrowed liquidity. Your ETH stays safe.
      </p>

      <h2>The Problem with Traditional DeFi Borrowing</h2>
      
      <p>
        Most DeFi lending protocols excel at one thing: <strong>unlocking liquidity</strong>. You supply collateral, borrow stablecoins or assets, and then... you're on your own.
      </p>
      
      <p>
        The critical question that platforms like Tydro don't answer is: <strong>"WHERE do I deploy this borrowed capital for maximum growth?"</strong>
      </p>
      
      <div className="warning-box">
        <div className="warning-title">The Capital Deployment Gap</div>
        <p>
          <strong>What most protocols tell you:</strong> "Borrow Assets. Deploy them into DeFi protocols."
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>What they don't tell you:</strong> Which protocols? Which tokens? How do I grow my borrowed capital? Where can I find new tokens to trade?
        </p>
      </div>

      <h2>Mavrk's Solution: Tydro Integrated Leveraged Spot Trading</h2>
      
      <p>
        We integrated <strong>Tydro's lending protocol</strong> directly into Mavrk's trading dashboard, creating the first <strong>seamless capital loop</strong> on Ink.
      </p>
      
      <div className="highlight-box">
        <div className="highlight-title">The Tydro → Mavrk Loop</div>
        <div className="highlight-text">
          Supply collateral → Borrow USDT0/kBTC → Trade Between Hundreds of Tokens → Manage positions → Repay debt → Keep profits
          <br /><br />
          <strong>All in one dashboard. Zero friction.</strong>
        </div>
      </div>

      <h3>Why This Changes Everything</h3>
      
      <div className="purple-box">
        <div className="purple-title">Relay Protocol Integration</div>
        <p>
          Typically, you need active trading liquidity routes to facilitate swaps. Want to buy a token with USDT0? You'd need a USDT0/TOKEN liquidity pool.
        </p>
        <p>
          <strong>We implemented Relay Protocol's swap widget</strong> to bypass this barrier entirely. Relay routes your USDT0 or kBTC through native WETH/TOKEN pools automatically.
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>Result:</strong> Your Tydro borrowed assets have <strong>immediate trading utility</strong> across 100+ tokens, even exotic pairs like USDT0/IKA or kBTC/DOGEIN.
        </p>
      </div>

      <h2>How to Use Tydro Leveraged Spot Trading</h2>
      
      <p>
        Access the integrated dashboard at: <a href="/tydro">mavrk.ink/tydro</a>
      </p>

      <div className="step">
        <div className="step-number">1</div>
        <div>
          <h3 className="step-title">Supply Collateral</h3>
          <div className="step-content">
            <p>
              Supply assets to Tydro's lending pools to use as collateral. You can supply:
            </p>
            <ul>
              <li><strong>ETH</strong> - Native Ethereum</li>
              <li><strong>WETH</strong> - Wrapped Ethereum</li>
              <li><strong>kBTC</strong> - Kraken Wrapped Bitcoin</li>
              <li><strong>USDT0</strong> - Bridged Tether</li>
            </ul>
            <p style={{ marginBottom: 0 }}>
              <strong>Your supplied assets earn APY</strong> from borrower interest while serving as collateral.
            </p>
          </div>
        </div>
      </div>

      <div className="success-box">
        <div className="success-title">Pro Tip: Start with ETH</div>
        <p style={{ marginBottom: 0 }}>
          ETH is the most liquid collateral asset on Ink and provides the best loan-to-value (LTV) ratio. You can borrow up to <strong>75% of your ETH value</strong> in USDT0 or kBTC.
        </p>
      </div>

      <div className="step">
        <div className="step-number">2</div>
        <div>
          <h3 className="step-title">Borrow USDT0 or kBTC</h3>
          <div className="step-content">
            <p>
              Once you've supplied collateral, borrow against it:
            </p>
            <ul>
              <li><strong>USDT0</strong> - Stablecoin pegged to $1 USD (best for most token trades)</li>
              <li><strong>kBTC</strong> - Wrapped Bitcoin (for BTC-denominated strategies)</li>
            </ul>
            <p style={{ marginBottom: 0 }}>
              Your <strong>health factor</strong> determines how much you can safely borrow. Keep it above <strong>1.5</strong> to avoid liquidation risk.
            </p>
          </div>
        </div>
      </div>

      <div className="example-box">
        <div className="example-title">Example: Borrowing with $10,000 ETH</div>
        <p><strong>Supplied Collateral:</strong> $10,000 in ETH</p>
        <p><strong>Maximum Borrow (75% LTV):</strong> $7,500 in USDT0 or kBTC</p>
        <p><strong>Recommended Borrow (50-60% LTV):</strong> $5,000-$6,000</p>
        <p style={{ marginBottom: 0 }}>
          <strong>Why conservative?</strong> Leaves cushion for price volatility and maintains safe health factor above 2.0
        </p>
      </div>

      <div className="step">
        <div className="step-number">3</div>
        <div>
          <h3 className="step-title">Deploy Borrowed Capital into Mavrk Tokens</h3>
          <div className="step-content">
            <p>
              This is where Mavrk's integration shines. Click the <strong>"Buy"</strong> button to access the token selector:
            </p>
            <ul>
              <li>Search from <strong>100+ Ink ecosystem tokens</strong></li>
              <li>View token info: name, symbol, market cap, creator</li>
              <li>Select your payment asset: <strong>USDT0</strong> or <strong>kBTC</strong></li>
              <li>Execute instant swaps via <strong>Relay Protocol</strong></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="purple-box">
        <div className="purple-title">The Relay Advantage</div>
        <p>
          Traditional DEXs require direct liquidity pools (e.g., USDT0/TOKEN). Most new tokens don't have these exotic pairs.
        </p>
        <p>
          <strong>Relay Protocol routes your swaps intelligently:</strong>
        </p>
        <p>
          USDT0 → WETH → TOKEN or kBTC → WETH → TOKEN
        </p>
        <p style={{ marginBottom: 0 }}>
          You trade with USDT0/kBTC, Relay handles the routing through native WETH pools. <strong>No liquidity barriers. Instant trading utility.</strong>
        </p>
      </div>

      <div className="step">
        <div className="step-number">4</div>
        <div>
          <h3 className="step-title">Amplify Your Capital (2-10x and Beyond)</h3>
          <div className="step-content">
            <p>
              The power of leveraged spot trading comes from <strong>identifying high-potential tokens early</strong> and deploying borrowed capital before major price movements.
            </p>
          </div>
        </div>
      </div>

      <div className="example-box">
        <div className="example-title">Real Growth Scenario</div>
        <p><strong>Starting Capital:</strong></p>
        <ul>
          <li>Supplied: $10,000 ETH (earns ~2-5% APY)</li>
          <li>Borrowed: $5,000 USDT0</li>
        </ul>
        <p><strong>Deployment Strategy:</strong></p>
        <ul>
          <li>$2,000 into $IKA (ecosystem utility token)</li>
          <li>$1,500 into top 3 trending tokens</li>
          <li>$1,000 into new launches (high risk/reward)</li>
          <li>$500 buffer (for volatility)</li>
        </ul>
        <p><strong>Growth Outcome (Conservative 5x):</strong></p>
        <ul>
          <li>$IKA position: $2,000 → $10,000</li>
          <li>Trending tokens: $1,500 → $4,500</li>
          <li>New launches: $1,000 → $2,000 (mixed results)</li>
        </ul>
        <p><strong>Total Position Value: $16,500</strong></p>
        <p><strong>Action:</strong> Sell positions back to USDT0</p>
        <p><strong>Repay Debt:</strong> $5,000 USDT0</p>
        <p style={{ marginBottom: 0, color: '#10b981', fontWeight: 700, fontSize: '1.1rem' }}>
          <strong>Profit Kept: $11,500</strong> (230% return on borrowed capital!)
        </p>
        <p style={{ fontSize: '0.9rem', color: '#9ca3af', marginTop: '1rem', marginBottom: 0 }}>
          Note: Your original $10,000 ETH is still in Tydro earning APY. You risked borrowed capital, not your base assets.
        </p>
      </div>

      <div className="warning-box">
        <div className="warning-title">Risk Management Essential</div>
        <p><strong>Smart traders:</strong></p>
        <ul>
          <li>Monitor health factor daily (keep above 1.5, ideally above 2.0)</li>
          <li>Don't deploy 100% of borrowed capital (keep 10-20% buffer)</li>
          <li>Set profit targets BEFORE entering positions (e.g., sell at 3x)</li>
          <li>Diversify across multiple tokens (don't YOLO into one)</li>
          <li>Start small to learn the mechanics before scaling</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>Remember:</strong> Leverage amplifies gains AND losses. Use responsibly.
        </p>
      </div>

      <div className="step">
        <div className="step-number">5</div>
        <div>
          <h3 className="step-title">Manage Positions & Repay Debt</h3>
          <div className="step-content">
            <p>
              The Mavrk dashboard provides real-time position tracking:
            </p>
            <ul>
              <li><strong>Token Positions:</strong> See all tokens you've bought with borrowed capital</li>
              <li><strong>Collateral Holdings:</strong> Monitor your supplied assets and earned APY</li>
              <li><strong>Debt Overview:</strong> Track borrowed amounts and health factor</li>
              <li><strong>Sell Function:</strong> Exit positions back to USDT0/kBTC instantly</li>
            </ul>
            
            <p><strong>When to Repay:</strong></p>
            <ul>
              <li>Hit profit targets (sell tokens at 2x, 5x, or 10x)</li>
              <li>Market downturn (exit positions to protect capital)</li>
              <li>Health factor risk (if HF drops below 1.8, consider repaying)</li>
              <li>Opportunities elsewhere (rotate capital to better plays)</li>
            </ul>
          </div>
        </div>
      </div>

      <h2>The Complete Capital Loop Strategy</h2>
      
      <div className="info-box">
        <div className="info-title">The Sustainable Loop</div>
        <p>
          The beauty of this system is <strong>repeatability</strong>. Once you understand the mechanics:
        </p>
        <ol>
          <li><strong>Keep collateral supplied</strong> - Earns APY continuously</li>
          <li><strong>Borrow conservatively</strong> - Maintain HF above 2.0</li>
          <li><strong>Deploy into opportunities</strong> - Use Mavrk's token discovery</li>
          <li><strong>Take profits at targets</strong> - Don't get greedy</li>
          <li><strong>Repay debt</strong> - Reset your position</li>
          <li><strong>Keep excess profits</strong> - Compound your gains</li>
          <li><strong>Repeat</strong> - More capital, more opportunity</li>
        </ol>
        <p style={{ marginBottom: 0 }}>
          <strong>Active traders</strong> who manage positions daily can potentially earn significantly more than passive APY through strategic token deployment and compounding gains.
        </p>
      </div>

      <h2>Why Mavrk + Tydro Works</h2>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', margin: '2rem 0' }}>
        <div className="purple-box">
          <div className="purple-title">Tydro Provides</div>
          <ul style={{ marginBottom: 0 }}>
            <li>Capital unlocking</li>
            <li>Flexible collateral</li>
            <li>Competitive APY</li>
            <li>Safe borrowing (Aave-powered)</li>
          </ul>
        </div>
        
        <div className="success-box">
          <div className="success-title">Mavrk Provides</div>
          <ul style={{ marginBottom: 0 }}>
            <li>100+ deployment targets</li>
            <li>Instant exotic pair trading</li>
            <li>Token discovery tools</li>
            <li>Integrated position management</li>
          </ul>
        </div>
      </div>
      
      <p>
        <strong>Together:</strong> A complete DeFi experience that takes you from idle capital to active growth opportunities in minutes.
      </p>

      <h2>Advanced Trading Strategies</h2>
      
      <h3>Strategy 1: The Diversified Deployer</h3>
      <div className="example-box">
        <div className="example-title">For Risk-Averse Traders</div>
        <p><strong>Borrowed Capital:</strong> $5,000 USDT0</p>
        <p><strong>Allocation:</strong></p>
        <ul>
          <li>40% ($2,000) - Established ecosystem tokens ($IKA, $TYDRO)</li>
          <li>30% ($1,500) - Mid-cap trending tokens</li>
          <li>20% ($1,000) - Small-cap growth plays</li>
          <li>10% ($500) - Cash buffer</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>Target:</strong> 3-5x average return | <strong>Risk Level:</strong> Medium
        </p>
      </div>
      
      <h3>Strategy 2: The Trend Rider</h3>
      <div className="example-box">
        <div className="example-title">For Active Traders</div>
        <p><strong>Borrowed Capital:</strong> $10,000 USDT0</p>
        <p><strong>Approach:</strong> Follow Mavrk's "Trending Tokens" and community favorites</p>
        <ul>
          <li>Deploy into top 5 trending tokens (momentum plays)</li>
          <li>Set stop-losses at -20% (protect capital)</li>
          <li>Take profits at 2x, 3x, 5x (staged exits)</li>
          <li>Rotate gains into next trending tokens</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>Target:</strong> 5-10x over multiple trades | <strong>Risk Level:</strong> High
        </p>
      </div>
      
      <h3>Strategy 3: The Early Bird</h3>
      <div className="example-box">
        <div className="example-title">For High-Risk/High-Reward</div>
        <p><strong>Borrowed Capital:</strong> $3,000 USDT0</p>
        <p><strong>Focus:</strong> New token launches (first 24-48 hours)</p>
        <ul>
          <li>Deploy into newly launched tokens before discovery</li>
          <li>Exit at 5-10x or on first major pullback</li>
          <li>Accept higher failure rate (50%+ might fail)</li>
          <li>One 10x winner covers multiple losers</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>Target:</strong> 10x+ on winners | <strong>Risk Level:</strong> Very High
        </p>
      </div>

      <h2>Maximize Earnings: APY + Trading Profits</h2>
      
      <p>
        Here's what most users don't realize: <strong>You earn on both sides</strong> of the loop.
      </p>
      
      <div className="success-box">
        <div className="success-title">Dual Income Streams</div>
        <p><strong>1. Supply APY (Passive Income)</strong></p>
        <ul>
          <li>Your collateral earns interest while supplied</li>
          <li>APY varies by asset utilization (typically 2-8% for ETH/WETH)</li>
          <li>Compounds automatically</li>
          <li>No action required</li>
        </ul>
        <p><strong>2. Trading Profits (Active Income)</strong></p>
        <ul>
          <li>Deploy borrowed capital into growing tokens</li>
          <li>Potential 2-10x+ returns on good picks</li>
          <li>Requires active management and research</li>
          <li>Higher risk, higher reward</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>The active traders in the trenches</strong> who monitor trends, manage positions daily, and deploy capital strategically can significantly outperform passive APY earnings through smart token selection and timing.
        </p>
      </div>

      <h2>Risk Management Best Practices</h2>
      
      <div className="warning-box">
        <div className="warning-title">Protect Your Capital</div>
        <p><strong>Health Factor Management:</strong></p>
        <ul>
          <li><strong>Above 2.0:</strong> Safe zone (recommended)</li>
          <li><strong>1.5 - 2.0:</strong> Caution zone (monitor closely)</li>
          <li><strong>Below 1.5:</strong> Danger zone (risk of liquidation)</li>
        </ul>
        <p><strong>Position Sizing:</strong></p>
        <ul>
          <li>Never deploy 100% of borrowed capital at once</li>
          <li>Keep 10-20% buffer for volatility</li>
          <li>Start with smaller positions to learn</li>
        </ul>
        <p><strong>Exit Planning:</strong></p>
        <ul>
          <li>Set profit targets BEFORE buying (e.g., "I'll sell at 3x")</li>
          <li>Don't move goalposts once in profit</li>
          <li>Take partial profits on the way up (sell 25% at 2x, 50% at 5x, etc.)</li>
        </ul>
        <p style={{ marginBottom: 0 }}>
          <strong>Golden Rule:</strong> It's better to repay your debt early and secure profits than to hold positions hoping for "one more pump." Protect your capital first.
        </p>
      </div>

      <h2>Complete Workflow Example</h2>
      
      <div className="example-box">
        <div className="example-title">Step-by-Step: Your First Leveraged Trade</div>
        
        <p><strong>Starting Position:</strong></p>
        <ul>
          <li>You have: 3 ETH (~$10,000)</li>
          <li>Goal: Trade tokens without selling ETH</li>
        </ul>
        
        <p><strong>Step 1: Supply ETH</strong></p>
        <ol>
          <li>Go to mavrk.ink/tydro</li>
          <li>Click "Supply" section, expand it</li>
          <li>Click "Supply" button next to ETH</li>
          <li>Enter: 3 ETH</li>
          <li>Confirm transaction</li>
          <li>Result: $10,000 collateral supplied, earning ~3% APY</li>
        </ol>
        
        <p><strong>Step 2: Borrow USDT0</strong></p>
        <ol>
          <li>Click "Borrow, Repay, Withdraw" section, expand it</li>
          <li>Click "Borrow" button next to aWETH (your collateral)</li>
          <li>Enter: $5,000 USDT0 (50% LTV - conservative)</li>
          <li>Confirm transaction</li>
          <li>Result: $5,000 USDT0 borrowed, Health Factor: 2.5 (safe)</li>
        </ol>
        
        <p><strong>Step 3: Buy Token</strong></p>
        <ol>
          <li>Click "Buy" button at top of dashboard</li>
          <li>Modal opens, search for token (e.g., "IKA")</li>
          <li>Select: Kaijin Ika ($IKA)</li>
          <li>Payment asset: USDT0</li>
          <li>Relay swap widget loads</li>
          <li>Enter: $2,000 USDT0</li>
          <li>Review: Getting ~40M IKA tokens at current price</li>
          <li>Confirm swap</li>
          <li>Result: Borrowed $2,000 deployed into $IKA position</li>
        </ol>
        
        <p><strong>Step 4: Monitor & Manage</strong></p>
        <ul>
          <li>Token appears in "Positions" section</li>
          <li>Track current value and P&L</li>
          <li>IKA pumps 5x over 2 weeks</li>
          <li>Position now worth: $10,000</li>
        </ul>
        
        <p><strong>Step 5: Take Profits</strong></p>
        <ol>
          <li>Click "Sell" button</li>
          <li>Select $IKA from holdings</li>
          <li>Sell 100% back to USDT0</li>
          <li>Receive: $10,000 USDT0</li>
        </ol>
        
        <p><strong>Step 6: Repay & Profit</strong></p>
        <ol>
          <li>Go to "Borrow, Repay, Withdraw" section</li>
          <li>Click "Manage", select "Repay" tab</li>
          <li>Repay: $2,000 USDT0 (original debt)</li>
          <li>Profit kept: $8,000 USDT0</li>
        </ol>
        
        <p style={{ marginBottom: 0, color: '#10b981', fontWeight: 700, fontSize: '1.1rem' }}>
          <strong>Final State:</strong><br />
          ETH still in Tydro: $10,000 + earned APY<br />
          Profit from trade: $8,000 (400% return on deployed capital!)<br />
          Total portfolio: $18,000+
        </p>
      </div>

      <h2>Why Leave Funds Supplied in Tydro</h2>
      
      <p>
        After repaying your debt, you might wonder: <strong>"Should I withdraw my collateral?"</strong>
      </p>
      
      <p>
        <strong>For active traders, the answer is often NO.</strong> Here's why:
      </p>
      
      <ul>
        <li><strong>Earn passive APY:</strong> Your supplied ETH/WETH/kBTC earns interest continuously</li>
        <li><strong>Instant re-deployment:</strong> See a new opportunity? Borrow and deploy in seconds</li>
        <li><strong>No gas waste:</strong> Avoid withdraw → re-supply gas fees</li>
        <li><strong>Capital efficiency:</strong> Your collateral is working even when you're not actively trading</li>
        <li><strong>Compounding:</strong> Earned APY + trading profits → larger collateral base → larger borrowing power</li>
      </ul>
      
      <div className="success-box">
        <div className="success-title">The Active Trader Advantage</div>
        <p>
          <strong>Passive investor:</strong> Supplies $10k ETH, earns 3% APY = $300/year
        </p>
        <p>
          <strong>Active loop trader:</strong> Supplies $10k ETH, earns 3% APY + makes 3-5 leveraged trades/month with 50% average success rate
        </p>
        <ul>
          <li>APY earnings: $300/year</li>
          <li>Winning trades: 2-3 per month × $3,000 avg profit = $6,000-$9,000/month</li>
          <li>Losing trades: -$1,000-$2,000/month (managed risk)</li>
          <li>Net trading profit: $5,000-$7,000/month</li>
        </ul>
        <p style={{ marginBottom: 0, fontWeight: 700, color: '#10b981' }}>
          <strong>Potential annual return:</strong> $60,000-$84,000 vs $300 passive APY
        </p>
        <p style={{ fontSize: '0.9rem', color: '#9ca3af', marginTop: '0.5rem', marginBottom: 0 }}>
          Note: Results vary. Requires research, risk management, and active position monitoring. Past performance doesn't guarantee future results.
        </p>
      </div>

      <h2>Technical Details</h2>
      
      <h3>Supported Collateral Assets</h3>
      <ul>
        <li><strong>ETH</strong> - Native Ethereum (18 decimals)</li>
        <li><strong>WETH</strong> - Wrapped Ethereum (18 decimals) - <code>0x4200000000000000000000000000000000000006</code></li>
        <li><strong>kBTC</strong> - Kraken Wrapped Bitcoin (8 decimals) - <code>0xEB21F5026610d8a983985FfaDC65a688A6D6c7Fc</code></li>
        <li><strong>USDT0</strong> - Bridged Tether (6 decimals) - <code>0xf7bc1F442d8A70F2710c6cC63F4dB5c706B23A95</code></li>
      </ul>
      
      <h3>Borrowable Assets</h3>
      <ul>
        <li><strong>USDT0</strong> - Best for trading most Mavrk tokens</li>
        <li><strong>kBTC</strong> - For Bitcoin-denominated strategies</li>
      </ul>
      
      <h3>Protocols & Integrations</h3>
      <ul>
        <li><strong>Tydro Protocol:</strong> Lending/borrowing (powered by Aave on Ink)</li>
        <li><strong>Relay Protocol:</strong> Swap routing for exotic pairs</li>
        <li><strong>Mavrk DEX:</strong> Native WETH/TOKEN liquidity pools</li>
      </ul>

      <h2>Common Questions</h2>
      
      <h3>What happens if my token investment drops and my health factor falls below 1.0?</h3>
      <p>
        Your collateral can be liquidated to repay the debt. This is why we recommend keeping health factor above 2.0, monitoring positions daily, and not over-leveraging.
      </p>
      
      <h3>Can I trade tokens I already own using this dashboard?</h3>
      <p>
        Yes! The "Sell" function works with any tokens in your wallet, not just tokens bought with borrowed capital.
      </p>
      
      <h3>How do I know which tokens have growth potential?</h3>
      <p>
        Mavrk provides several discovery tools: Community Favorites, Trending Tokens, New Launches, Market Cap filters, and Creator reputation info.
      </p>
      
      <h3>What's the minimum I can borrow?</h3>
      <p>
        There's no strict minimum, but for gas efficiency on Ink L2, we recommend borrowing at least $100-$500 USDT0.
      </p>
      
      <h3>Can I repay my debt partially?</h3>
      <p>
        Absolutely! You can repay any amount at any time. Many traders repay in stages as they take profits.
      </p>
      
      <h3>What are the fees?</h3>
      <p><strong>Tydro Fees:</strong></p>
      <ul>
        <li>Borrowing interest: Varies by utilization (typically 0-5% APY)</li>
        <li>No supply fees (you earn APY instead)</li>
      </ul>
      <p><strong>Mavrk Fees:</strong></p>
      <ul>
        <li>Trading fee: 1% per swap (0.5% to LP, 0.5% to creator)</li>
      </ul>

      <div className="highlight-box">
        <div className="highlight-title">Ready to Amplify Your Capital?</div>
        <div className="highlight-text">
          Start leveraged spot trading on Mavrk today.
          <br /><br />
          <a href="/tydro" style={{ color: '#10b981', fontSize: '1.2rem', fontWeight: 700 }}>
            Launch Tydro Leveraged Trading
          </a>
          <br /><br />
          <span style={{ fontSize: '0.9rem', color: '#9ca3af' }}>
            Tydro unlocks your capital. Mavrk shows you where to deploy it.
          </span>
        </div>
      </div>

      <div className="warning-box">
        <div className="warning-title">Risk Disclaimer</div>
        <p>
          Leveraged trading involves significant risk. You can lose more than your initial investment if positions move against you and your collateral is liquidated.
        </p>
        <p>
          Token prices are highly volatile. Past performance is not indicative of future results. The examples shown are for educational purposes and should not be considered financial advice.
        </p>
        <p style={{ marginBottom: 0 }}>
          Always conduct your own research, understand the risks, and never invest more than you can afford to lose. Start with small positions to learn the mechanics before scaling up.
        </p>
      </div>

      <h2>Additional Resources</h2>
      
      <ul>
        <li><a href="/tydro">Tydro Leveraged Trading Dashboard</a></li>
        <li><a href="/explore">Explore Mavrk Tokens</a></li>
        <li><a href="/docs/token-trading">Token Trading Guide</a></li>
        <li><a href="https://tydro.finance" target="_blank" rel="noopener noreferrer">Tydro Protocol Website</a></li>
        <li><a href="https://relay.link" target="_blank" rel="noopener noreferrer">Relay Protocol Documentation</a></li>
      </ul>
      
      <p style={{ marginTop: '3rem', fontSize: '0.9rem', color: '#9ca3af', textAlign: 'center' }}>
        Questions? Reach out to our community on <a href="https://x.com/mavrkofficial" target="_blank" rel="noopener noreferrer">X/Twitter</a>
      </p>
    </DocsPage>
  );
};

export default TydroLeveragedTrading;
